import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { formatApiError } from "@/lib/api";
import Navbar from "@/components/Navbar";
import useSeo from "@/lib/useSeo";

export default function AdminLogin() {
  useSeo({
    title: "Administrator Sign In — Langwood360",
    description: "Administrator sign-in.",
    path: "/admin/login",
    noindex: true,
  });
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-linen">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-24">
        <div className="tick-label-accent mb-6">Administrator</div>
        <h1 className="display-serif text-4xl">Sign in.</h1>
        <form onSubmit={submit} className="mt-10 space-y-5 border border-oxford/15 bg-linen p-8">
          <div>
            <label className="tick-label block mb-2">Email</label>
            <input data-testid="admin-email" required type="email" value={email} onChange={e=>setEmail(e.target.value)} className="w-full border border-oxford/20 px-3 py-3 bg-parchment focus:outline-none focus:border-oxford" />
          </div>
          <div>
            <label className="tick-label block mb-2">Password</label>
            <input data-testid="admin-password" required type="password" value={password} onChange={e=>setPassword(e.target.value)} className="w-full border border-oxford/20 px-3 py-3 bg-parchment focus:outline-none focus:border-oxford" />
          </div>
          {err && <div className="text-heritage text-sm" data-testid="admin-login-error">{err}</div>}
          <button type="submit" data-testid="admin-login-submit" disabled={loading} className="btn-orange w-full justify-center">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <div className="mt-6 text-sm text-charcoal"><Link to="/" className="hover:text-oxford">← Return home</Link></div>
      </div>
    </div>
  );
}
